import { Outlet } from '@tanstack/react-router';
import { House, Paperclip, Plant } from '@phosphor-icons/react';
import type { SubNavConfig, SubNavItem } from '../../contexts/SubNavContext';

// Test users live under each application's "Test Users" tab
// (/applications/$propertyId/credentials) rather than a top-level section.
const baseNavItems: SubNavConfig['items'] = [
  {
    id: 'properties',
    label: 'Applications',
    icon: <House size={16} />,
    to: '/test-data',
  },
  {
    id: 'attachments',
    label: 'Attachments',
    icon: <Paperclip size={16} />,
    to: '/test-data/attachments',
  },
];

const seedDataNavItem: SubNavItem = {
  id: 'seed-data',
  label: 'Seed Data',
  icon: <Plant size={16} />,
  to: '/test-data/seed-data',
};

function getTestDataNavItems(): SubNavConfig['items'] {
  const items = [...baseNavItems];
  items.push(seedDataNavItem);
  return items;
}

export function buildTestDataNavConfig(): SubNavConfig {
  const items = getTestDataNavItems();
  return {
    title: 'Test Data',
    basePath: '/test-data',
    items,
    getActiveId: ({ pathname }) => {
      if (!pathname.startsWith('/test-data')) return undefined;
      const maybeSection = pathname.split('/')[2];
      if (!maybeSection || maybeSection.length === 0) return 'properties';
      const hasMatch = items.some((item) => item.id === maybeSection);
      return hasMatch ? maybeSection : 'properties';
    },
  };
}

export function TestDataLayout() {
  // Sub-nav is set by child pages (TestDataPage, TestDataPropertyDetail)
  // rather than at the layout level, so it restores correctly after
  // navigating between sections and property detail views.
  return <Outlet />;
}
